// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Ad8k","filesListContainer":"PosDisputesFiles_filesListContainer__1xCYr","filesButton":"PosDisputesFiles_filesButton__bzsq3"};